import type { OfferingType } from '../types/lesson';

/**
 * One human label for what a lesson was bought as.
 *
 * Lifted out of PlayerSegmentLibrary, which held the only copy, so the picker's
 * group headers and the player's fullscreen title cannot drift apart.
 *
 * The offering type lives on the *order*, not the lesson, and `totalLessons`
 * with it; only `lessonNumber` is on the lesson. Callers therefore have to
 * supply both halves.
 */
export function formatOfferingLabel(meta: {
  offeringType?: OfferingType;
  lessonNumber?: number;
  totalLessons?: number;
}): string {
  if (meta.offeringType === 'shot_consult') return 'Shot Consult';
  if (meta.offeringType === 'training_program' && meta.lessonNumber != null && meta.totalLessons != null) {
    return `Lesson ${meta.lessonNumber} of ${meta.totalLessons}`;
  }
  return 'Single Lesson';
}
